module.exports = __webpack_public_path__ + "img/enjoy_black_small.aaaa7f4a.png";